import { v4 as uuid } from "uuid";
import * as CustomerConst from "actions/customerConst";
import { useSelector, useDispatch } from 'react-redux'

import store from '@/redux/store';
import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import CustomerAPI from "@/api/CustomerAPI";
import {switchTenant} from "@/reducers/Modal"
//import  {ICustomer, CustomerModel} from "@/models/Customer";
import  {CompanyModel as CustomerModel} from "@/models/PPC/Company";

import * as reducerBase from "@/reducers/initialValues/Customer";

// export const initialState = {
//   showModal: "",
//   isInProgress: false,
//   showSheet: false,
//   status: CustomerConst.CUSTOMER_STATE_IDLE,
//   customers: false,
//   selected: new CustomerModel(),
//   customerModel: new CustomerModel(),
//   error: null
// };
export const loadCustomers = createAsyncThunk(
  CustomerConst.LOAD_CUSTOMERS,
  // The payload creator receives the partial `{title, content, user}` object
  async (initialPost, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
        response = await CustomerAPI.get();


      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const loadCustomer = createAsyncThunk(
  CustomerConst.LOAD_CUSTOMER,
  // The payload creator receives the partial `{title, content, user}` object
  async (customerId:any, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
        
      response = await CustomerAPI.get(customerId);


      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const addCompany = createAsyncThunk(
  CustomerConst.ADD_COMPANY,
  // The payload creator receives the partial `{title, content, user}` object
  async (data:any, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
        response = await CustomerAPI.storeCompany(data);
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)


export const addCustomer = createAsyncThunk(
  CustomerConst.ADD_CUSTOMER,
  // The payload creator receives the partial `{title, content, user}` object
  async (data:any, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await CustomerAPI.storeCustomer(data);
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const removeCustomer = createAsyncThunk(
  CustomerConst.REMOVE_CUSTOMER,
  // The payload creator receives the partial `{title, content, user}` object
  async (customerKey, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await CustomerAPI.deleteCustomer(customerKey);
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)


const CustomerReducer = createSlice({
  name: 'customer',
  initialState: reducerBase.initialState,
  reducers: {
      setMapId(state, action) {
          if(action.type == "posts/setMapId") {
            state.selectedMap = action.payload.mapId

            filterOnFile(state);
            }
        },
        unsetSelected(state, action) {
            let customer = new CustomerModel();

            //customer.createAddress();
            state.selected = customer;
        },
        newCustomer(state, action) {
            let customer = new CustomerModel();
            state.selected = customer;
            return state.selected;

        }

    // omit existing reducers here
  },
  extraReducers(builder) {
     builder.addCase(removeCustomer.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
        state.status = CustomerConst.CUSTOMER_STATE_IDLE
        state.error = null;
        state.customers = action.payload.data.data.original.data;
    });

    //  builder.addCase(loadCustomers.fulfilled, (state, action) => {
    //   console.clear();
    //   // We can directly add the new post object to our posts array
    //     state.status = CustomerConst.CUSTOMER_STATE_IDLE
    //     state.error = null;
    //     state.customers = action.payload.data.data;

    // }).addCase(loadCustomers.rejected, (state, action) => {
    //     state.status = CustomerConst.CUSTOMER_STATE_ERROR
    //     state.error = action.payload
    //   });


     builder.addCase(loadCustomer.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
        state.status = CustomerConst.CUSTOMER_STATE_IDLE
        state.error = null;
        state.selected = new CustomerModel(action.payload.data.data);

    }).addCase(loadCustomer.rejected, (state, action) => {
        state.status = CustomerConst.CUSTOMER_STATE_ERROR
        state.error = action.payload
      });

     builder.addCase(addCustomer.fulfilled, (state, action) => {
        reducerBase.fullFilledEventHandler(state, action);

    }).addCase(addCustomer.rejected, (state, action) => {
        state.status = CustomerConst.CUSTOMER_STATE_ERROR
        state.error = action.payload
      }).addCase(addCompany.rejected, (state, action) => {
        reducerBase.rejectEventHandler(state, action);
      });

    builder.addCase(switchTenant.fulfilled, (state, action) => {
        state.selected = false;
        state.customers = false;

    });

    builder.addMatcher(
      (action) => (action.type.indexOf('CUSTOMER') >=0 || action.type.indexOf('COMPANY') >=0),
      (state, action) => {
          let actionTypeKeys = action.type.split('/');
          if(Array.isArray(actionTypeKeys) && actionTypeKeys.length >= 2) {
            let lastActionTypeKey = actionTypeKeys.pop();
            switch(lastActionTypeKey.toLowerCase()) {
              case 'fulfilled':
                reducerBase.fullFilledEventHandler(state, action);
                break;
              case 'pending':
                reducerBase.pendingEventHandler(state, action);
                break;
              case 'rejected':
                reducerBase.rejectEventHandler(state, action);
                break;
            }
          }

      });


  }
})
export const { unsetSelected, newCustomer } = CustomerReducer.actions;
export default CustomerReducer.reducer
